import { FC, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useI18n from "../../../../../hooks/useTranslations";
import Button from "../../../../ui/Button";
import FlexContent from "../../../../ui/FlexContent";
import ModalDialog from "../../../../ui/ModalDialog";
import SubstructureForm from "./SubstructureForm";

const CreateSubstructureModalDialogButton: FC = () => {
  const i18n = useI18n();
  const navigate = useNavigate();
  const { systemId } = useParams<{ systemId: string }>();
  const [showNewItemDialog, setShowNewItemDialog] = useState(false);

  return (
    <>
      <Button buttonProps={{ onClick: () => setShowNewItemDialog(true) }}>{i18n.translation.common.createNew}</Button>
      {showNewItemDialog && (
        <ModalDialog
          onClose={() => setShowNewItemDialog(false)}
          title={i18n.translation.substructures.createNew}
          fitContent
        >
          <FlexContent direction="row">
            <SubstructureForm
              onSubmitSuccess={(substructureId) =>
                navigate(`/admin/systems/${systemId}/substructures/${substructureId}`)
              }
            />
          </FlexContent>
        </ModalDialog>
      )}
    </>
  );
};

export default CreateSubstructureModalDialogButton;
